import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ThemeContext } from 'styled-components';
import Heading from '../../Atoms/Heading/Heading';
import { HeadingSizeType } from '../../Atoms/Heading/Heading.enum';
import Icon from '../../Atoms/Icon/Icon';
import { IconName, IconSize } from '../../Atoms/Icon/Icon.enum';
import { ToastrWrapperBase, ToastrWrapperContent } from './BaseComponents/ToastrWrapperBase';
import { getToastrTypeIconSetup } from './Toastr.helpers';
const Toastr = ({ text, closeIcon, displayTimeMs, toastrType }) => {
    const [isBrowser, setIsBrowser] = useState(false);
    const [isToastrOpen, setIsToastrOpen] = useState(true);
    const theme = useContext(ThemeContext);
    const toastrIconSetup = getToastrTypeIconSetup(theme, toastrType);
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    useEffect(() => {
        setTimeout(() => {
            setIsToastrOpen(false);
        }, displayTimeMs || 8000);
    }, [displayTimeMs]);
    const getToastrWrapper = () => {
        let wrapper = document.getElementById('toastr-wrapper');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.setAttribute('id', 'toastr-wrapper');
            wrapper.setAttribute('data-testid', 'toastr-wrapper');
            document.body.appendChild(wrapper);
        }
        return wrapper;
    };
    const closeToastr = () => {
        if (!closeIcon)
            return;
        setIsToastrOpen(false);
    };
    const getToastrContent = () => isToastrOpen && (_jsx(ToastrWrapperBase, { children: _jsxs(ToastrWrapperContent, Object.assign({ "data-testid": "toastr-content", onClick: closeToastr }, { children: [_jsx(Icon, { className: "toast-icon", color: toastrIconSetup.color, name: toastrIconSetup.iconName, size: IconSize.SIZE16 }, void 0), _jsx(Heading, Object.assign({ as: "span", textSize: HeadingSizeType.TITLE14 }, { children: text }), void 0), closeIcon && _jsx(Icon, { name: IconName.CLOSE, size: IconSize.SIZE16 }, void 0)] }), void 0) }, void 0));
    return _jsx(_Fragment, { children: isBrowser && ReactDOM.createPortal(getToastrContent(), getToastrWrapper()) }, void 0);
};
export default Toastr;
//# sourceMappingURL=Toastr.js.map